import styled from 'styled-components'

export const Container = styled.div`
  .opacity {
    opacity: 0.2;
  }

  .publishing {
    margin-top: 1.875rem;
    margin-bottom: auto;
  }
`

Container.displayName = 'Container'

export const PinPostContainer = styled.div`
  width: 2.625rem;
  height: var(--spacer-6);
`

PinPostContainer.displayName = 'PinPostContainer'

export const MediaWrapper = styled.div`
  min-width: 6.25rem;
`

MediaWrapper.displayName = 'MediaWrapper'
